import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class WorksShiftsApi extends ApiModule {
	constructor() {
		super(ModulesMap.WORKS_SHIFT, {
			entity: 'works_shift',
		})
	}
}
